
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/flex",
      function () {
        return require("private-next-pages/flex/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/flex"])
      });
    }
  